import React, { FC, ButtonHTMLAttributes } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisH } from '@fortawesome/free-solid-svg-icons';
import { ASSETS_PATH } from '@app/react/const/variables';
import { useMediaMobile } from '@app/react/common/useMedia';

export type ZoomButtonProps = ButtonHTMLAttributes<HTMLButtonElement>;

export const ZoomButton: FC<ZoomButtonProps> = ({ onClick, ...args }) => {
    const isMobile = useMediaMobile();

    return (
        <button
            type="button"
            className="product-thumbnail__icon-zoom"
            onClick={onClick}
            {...args}
        >
            {isMobile
            ? (
                <FontAwesomeIcon
                    icon={faEllipsisH}
                    color="#676767"
                />
            )
            : (
                <img
                    src={`${ASSETS_PATH}/img/common/icon-zoom.svg`}
                    alt="詳細"
                />
            )}
        </button>
    );
};
